import {t} from '@lingui/macro'
import {toast} from 'react-hot-toast'

export const errorMultiImagesToast = () =>
  toast.error(
    t`Only one image may be selected, therefore only the first one will be used`
  )
